import { useEffect, useRef } from 'react';
import './App.css';

function App() {
  const ref = useRef(null)

  useEffect(() => {
    if (ref)
    setTimeout(() => {
      ref.current.style.display = 'none'
    }, 2000)
  }, [ref])

  return (
    <div className="App">
      <div className="black" ref={ref} />
      <iframe src="https://artogo.co/zh-TW/exhibition/Li-Tai-Hsiang-and-His-Dreamland/space/df8aa21224c8?mode=embed" width="100%" height="100%" title='《夢土上的李泰祥》' />
    </div>
  );
}

export default App;
